import { render, staticRenderFns } from "./AIContentHistory.vue?vue&type=template&id=6ff99252&"
import script from "./AIContentHistory.vue?vue&type=script&lang=js&"
export * from "./AIContentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports